/*
 * md5加密
 * @param {string} str 加密字符串
 * @returns {string} 加密后的字符串
 */
import { md5 } from '@tencent/qd-lib';
export default md5;
